require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka.json") })
        }
      }, "path---betreuung-10-14-betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka!./.cache/json/betreuung-10-14-betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka.json
// module id = 838
// module chunks = 231608221292675